import { AdminUserRealm } from 'further-types/admin-user';
import { IncomeOrExpenseType } from 'further-types/lp/income-and-expenses';
import { FundingSource } from 'further-types/lp/investment';

export enum CreateAddInvestmentTransferStep {
  Form = 'form',
  Summary = 'summary',
}

export const HOMEPAGE = '/';
export const LOGOUT = '/logout';

export const ADVISER = '/adviser';
export const ADVISER_ADD = '/add-adviser';
export const ADVISER_VIEW = '/view-adviser/:id';
export const createAdviserViewRoute = (id: string) =>
  ADVISER_VIEW.replace(':id', id);
export const ADVISER_EDIT = '/update-adviser/:id';
export const createAdviserEditRoute = (id: string) => `/update-adviser/${id}`;

export const ALL_FUNDS = '/all-tranches';

export const COMPANY = '/company';
export const COMPANY_ADD = '/add-company';
export const COMPANY_DUPLICATE = '/duplicate-company/:id';
export const createCompanyDuplicateRoute = (id: string) =>
  COMPANY_DUPLICATE.replace(':id', id);
export const COMPANY_EDIT = '/edit-company/:id';
export const createCompanyEditRoute = (id: string) => `/edit-company/${id}`;

export const COMMITMENTS = '/commitments';
export const COMMITMENTS_VIEW = '/view-commitment/:investorId';
export const createCommitmentViewRoute = (
  investorId: string,
  commitmentId?: string,
) => {
  const path = COMMITMENTS_VIEW.replace(':investorId', investorId);

  if (!commitmentId) return path;

  const params = new URLSearchParams({ commitment: commitmentId });
  return `${path}?${params.toString()}`;
};

export const FEE_MANAGER = '/fee-manager';

export const DASHBOARD = '/dashboard';
export const DASHBOARD_ALL_FIRMS = '/dashboard/all-firms';
export const DASHBOARD_CLOSED_TRANCHE = '/dashboard/closed-tranche/:trancheId';
export const createClosedTrancheRoute = (id: string) =>
  `/dashboard/closed-tranche/${id}`;
export const DASHBOARD_MY_FIRM = '/dashboard/my-firm';
export const DASHBOARD_OPEN_TRANCHE = '/dashboard/open-tranche/:trancheId';
export const createOpenTrancheRoute = (id: string) =>
  `/dashboard/open-tranche/${id}`;
export const DASHBOARD_SINGLE_FIRM = '/dashboard/firm/:firmId';
export const createSingleFirmRoute = (id: string) => `/dashboard/firm/${id}`;

export const EIS = '/eiswizard';
export const EIS_ADD = '/add-eiswizard';
export const KI_EIS_ADD = '/add-ki-fund-certificate-batch';
export const KI_EIS_EDIT = '/ki-fund-certificate-batch/:batchId';
export const EIS_EDIT = '/edit-eiswizard/:id';
export const createKiFundCertificatesBatchEditRoute = (id: string) =>
  `/ki-fund-certificate-batch/${id}`;
export const createEisEditRoute = (id: string) => `/edit-eiswizard/${id}`;

export const TAX_REPORT_AUDIT = '/tax-report-audit';
export const TAX_REPORT_PDF_DOWNLOAD =
  '/tax-report-audit/pdf-download/:taxYearStart/:firmId';
export const createTaxReportPdfDownloadRoute = (
  taxYearStart: number,
  firmId: string,
) => `/tax-report-audit/pdf-download/${taxYearStart}/${firmId}`;

export const ERROR_404 = '/404';

export const EXITS = '/exits/list';
export const EXITS_ADD = '/exits/process-new-exit';
export const EXITS_EDIT = '/exits/edit/:id';
export const EXITS_CORRECT = '/exits/correct/:id';
export const createExitEditRoute = (id: string) => `/exits/edit/${id}`;
export const createExitCorrectRoute = (id: string) => `/exits/correct/${id}`;

export const FEE_DISCOUNT_ADD = '/add-fee-discount';
export const CORE_FEE_TEMPLATES = '/core-fee-templates';
export const CORE_FEE_TEMPLATE_ADD = '/create-core-fee-template';
export const CORE_FEE_TEMPLATE_EDIT = '/edit-core-fee-template/:id';
export const createCoreFeeTemplateEditRoute = (id: string) =>
  `/edit-core-fee-template/${id}`;
export const PERFORMANCE_FEE_TEMPLATES = '/performance-fee-templates';
export const PERFORMANCE_FEE_TEMPLATE_ADD = '/create-performance-fee-template';
export const PERFORMANCE_FEE_TEMPLATE_EDIT =
  '/edit-performance-fee-template/:id';
export const createPerformanceFeeTemplateEditRoute = (id: string) =>
  `/edit-performance-fee-template/${id}`;

export const ONE_OFF_FEES_AND_DISCOUNTS = '/one-off-fees-and-discounts';
export const FEE_DISCOUNT_SUCCESS = '/fee-or-discount-success';
export const FEE_SUMMARY = '/fee-summary';

export const FIRM = '/firm';
export const FIRM_ADD = '/add-firm';
export const FIRM_EDIT = '/edit-firm/:id';
export const createFirmEditRoute = (id: string) => `/edit-firm/${id}`;

export const SUBSCRIPTION_FUNNEL = '/subscription-funnel';

export const INTEREST_PAYMENTS = '/interest-payments';
export const INTEREST_PAYMENTS_ADD = '/interest-payments/create';

export const INVESTMENT = '/investment';
export const INVESTMENT_VIEW = '/view-investment/:id';
export const INVESTMENT_EDIT_LEGACY = '/edit-investment/:id';
export const createInvestmentViewLink = (id: string) =>
  `/view-investment/${id}`;
export const createInvestmentEditRoute = (id: string) =>
  `/edit-investment/${id}`;
export const createInvestmentsListByFundRoute = (id: string) =>
  `${INVESTMENT}?fundId=${id}`;
export const INVESTMENT_ADD = '/add-investment';

export const BULK_PAYMENT_ASSIGNMENT = '/bulk-payment-assignment';

export const FURTHER_USER = '/user';

export const INVESTOR = '/investor';
export const INVESTOR_EDIT = '/edit-investor/:id';
export const INVESTOR_ADD = '/add-investor';
export const createInvestorEditRoute = (id: string) => `/edit-investor/${id}`;
export const INVESTOR_UPLOAD = '/upload-investor-investment';
export const INVESTOR_VIEW = '/view-investor/:id';
export const createInvestorViewRoute = (id: string) => `/view-investor/${id}`;
export const ONGOING_AML_REVIEW = '/ongoing-aml-review';

export const INVESTOR_REPORTING = '/investor-reporting';
export const INVESTOR_REPORTING_ADD = '/add-update-investor-reporting';
export const INVESTOR_REPORTING_EDIT = '/add-update-investor-reporting/:id';
export const createInvestorReportingEditRoute = (id: string) =>
  `/add-update-investor-reporting/${id}`;
export const INVESTOR_REPORTING_SUCCESS = '/investor-reporting/success/:id';
export const createInvestorReportingEditSuccessRoute = (id: string) =>
  `/investor-reporting/success/${id}`;
export const INVESTOR_REPORTING_VIEW = '/view-investor-reporting/:id';
export const createInvestorReportingViewRoute = (id: string) =>
  `/view-investor-reporting/${id}`;
export const INVESTOR_REPORTING_PDF_DOWNLOAD =
  '/investor-reporting/pdf-download/:id';
export const createInvestorReportingPdfDownloadRoute = (id: string) =>
  `/investor-reporting/pdf-download/${id}`;

export const EXIT_STATEMENT_PDF_DOWNLOAD =
  '/exit-statement/pdf-download/:exitStatementId';
export const createExitStatementPdfDownloadRoute = (exitStatementId: string) =>
  `/exit-statement/pdf-download/${exitStatementId}`;

export const ORGANISATION = '/organisation';
export const ORGANISATION_ADD = '/add-organisation';
export const ORGANISATION_EDIT = '/update-organisation/:id';
export const createOrganisationEditRoute = (id: string) =>
  `/update-organisation/${id}`;
export const ORGANISATION_VIEW = '/view-organisation/:id';
export const createOrganisationViewRoute = (id: string) =>
  ORGANISATION_VIEW.replace(':id', id);
export const ORGANISATION_ADD_USER = '/add-organisation-user/:organisationId';
export const createOrganisationAddUserRoute = (id: string) =>
  ORGANISATION_ADD_USER.replace(':organisationId', id);

export const PROFILE = '/profile';
export const LP_PROFILE = '/profile/lp';
export const createProfileRoute = (realm: AdminUserRealm | undefined) =>
  realm === AdminUserRealm.Lp ? LP_PROFILE : PROFILE;

export const ADMIN_USER_ROLES = '/admin-user-roles';
export const ADMIN_USER_ROLE_CREATE = '/admin-user-roles/create/:newRoleRealm';
export const createAdminUserRoleCreateRoute = (newRoleRealm: AdminUserRealm) =>
  ADMIN_USER_ROLE_CREATE.replace(':newRoleRealm', newRoleRealm);
export const ADMIN_USER_ROLE_EDIT = '/admin-user-roles/edit/:id';
export const createAdminUserRoleEditRoute = (id: string) =>
  ADMIN_USER_ROLE_EDIT.replace(':id', id);
export const ADMIN_USER_ROLE_VIEW = '/admin-user-roles/view/:id';
export const createAdminUserRoleViewRoute = (id: string) =>
  ADMIN_USER_ROLE_VIEW.replace(':id', id);

export const TAG = '/tag';
export const BILLING = '/billing';
export const TAG_ADD = '/add-tag';
export const TAG_EDIT = '/edit-tag/:id';
export const createTagEditRoute = (id: string) => `/edit-tag/${id}`;

export const TRANCHE = '/tranche';
export const TRANCHE_REDESIGN = '/tranche/v2';
export const createTrancheListRoute = (useV2?: boolean) =>
  useV2 ? TRANCHE_REDESIGN : TRANCHE;
export const TRANCHE_ADD = '/add-tranche';
export const TRANCHE_ADD_REDESIGN = '/add-tranche/v2';
export const createTrancheAddRoute = (useV2?: boolean) =>
  useV2 ? TRANCHE_ADD_REDESIGN : TRANCHE_ADD;
export const TRANCHE_EDIT = '/edit-tranche/:id';
export const TRANCHE_EDIT_REDESIGN = '/edit-tranche/v2/:id';
export const createTrancheEditRoute = (id: string, useV2?: boolean) =>
  useV2 ? `/edit-tranche/v2/${id}` : `/edit-tranche/${id}`;
export const TRANCHE_BESPOKE_LINK = '/tranche-bespoke-link';

export const ALLOCATION_HISTORY = '/allocations';

export const CREATE_ALLOCATION = '/create-allocation';
export const VIEW_DRAFT_ALLOCATION =
  '/view-draft-allocation/:draftAllocationId';
export const createViewDraftAllocationRoute = (draftAllocationId: string) =>
  `/view-draft-allocation/${draftAllocationId}`;
export const VIEW_ALLOCATION = '/view-allocation/:id';
export const createViewAllocationRoute = (id: string) =>
  `/view-allocation/${id}`;

export const ADMIN_USER = '/admin-user';
export const ADMIN_USER_ADD = '/add-admin-user';
export const ADMIN_USER_EDIT = '/edit-admin-user/:id';
export const createAdminUserEditRoute = (id: string) =>
  `/edit-admin-user/${id}`;

export const FIRM_USER_ADD = '/add-firm-user';
export const FIRM_USER_EDIT = '/edit-firm-user/:id';
export const createFirmUserEditRoute = (id: string) => `/edit-firm-user/${id}`;

export const WITHDRAWALS = '/withdrawals';
export const WITHDRAWALS_ADD = '/withdrawals-request';

export const SHARE_SPLIT_ADD = '/add-share-split/:companyId';
export const createShareSplitAddRoute = (id: string) =>
  `/add-share-split/${id}`;

export const INVESTOR_BULLETIN = '/investor-bulletin';

export const ADD_CUSTOM_UPDATE = '/add-custom-update';
export const EDIT_CUSTOM_UPDATE = '/edit-custom-update/:id';
export const VIEW_CUSTOM_UPDATE = '/view-custom-update/:id';
export const createCustomUpdateViewRoute = (id: string) =>
  `/view-custom-update/${id}`;
export const createCustomUpdateEditRoute = (id: string) =>
  `/edit-custom-update/${id}`;
export const ADD_DEPLOYMENT_UPDATE =
  '/add-deployment-update/:shareAllocationUploadId/:companyId';
export const createDeploymentUpdateAddRoute = (id: string, companyId: string) =>
  `/add-deployment-update/${id}/${companyId}`;
export const createDeploymentUpdateViewRoute = (id: string) =>
  `/view-deployment-update/${id}`;
export const VIEW_DEPLOYMENT_UPDATE = '/view-deployment-update/:id';

export const ADD_EXIT_STATEMENT = '/add-exit-statement/:id/:exitAmendmentId?';
export const createExitStatementAddRoute = (
  id: string,
  exitAmendmentId?: string,
) =>
  exitAmendmentId
    ? `/add-exit-statement/${id}/${exitAmendmentId}`
    : `/add-exit-statement/${id}`;

export const UPDATE_EXIT_STATEMENT = '/update-exit-statement/:id';
export const createUpdateExitStatementRoute = (exitStatementId: string) =>
  `/update-exit-statement/${exitStatementId}`;

export const VIEW_EXIT_STATEMENT = '/view-exit-statement/:id';
export const createExitStatementViewRoute = (exitStatementId: string) =>
  `/view-exit-statement/${exitStatementId}`;

export const CHANGE_LOG = '/change-log';

export const INVESTMENT_TRANSFERS = '/investment-transfers';
export const ADD_INVESTMENT_TRANSFER =
  '/add-investment-transfer/:investorId/:step?';
export const createAddInvestmentTransferRoute = (
  investorId: string,
  step = CreateAddInvestmentTransferStep.Form,
) =>
  ADD_INVESTMENT_TRANSFER.replace(':investorId', investorId).replace(
    ':step',
    step ?? '',
  );

export const CASH_TRANSACTIONS_REPORT = '/cash-transactions-report';
export const INVESTMENT_HOLDINGS_REPORT = '/investment-holdings-report';
export const INVESTMENT_TRANSACTIONS_REPORT = '/investment-transactions-report';
export const PORTAL_USAGE_DATA_REPORT = '/portal-usage-data-report';

//LP Routes
export enum FundSetupTab {
  FundSetup = 'general',
  UserManagement = 'userManagement',
  ApprovalFlows = 'approvalFlows',
  ChartOfAccounts = 'chartOfAccounts',
  AccountMapping = 'accountMapping',
  FeeSettings = 'feeSettings',
  CarrySettings = 'carrySettings',
  EqualisationInterest = 'equalisationInterest',
}

export enum BankReconciliationTab {
  ReconcileTransactions = '#reconcileTransactions',
  BankStatement = '#bankStatement',
  ReconciledTransactions = '#reconciledTransactions',
  AccountSettings = '#accountSettings',
}

export enum AccountingTab {
  GeneralLedger = 'general-ledger',
  TrialBalance = 'trial-balance',
  BalanceSheet = 'balance-sheet',
  IncomeStatement = 'income-statement',
  CashFlowStatement = 'cash-flow-statement',
  ScheduleOfInvestments = 'schedule-of-investments',
}

export enum OnboardingTab {
  Overview = 'overview',
  DataRoom = 'data-room',
  DocumentSigning = 'document-signing',
  Settings = 'settings',
}

export const ACCOUNTING = '/accounting';
export const FUND_SETUP = '/fund-setup';
export const LP_FIRM_ADD = '/add-lp-firm';

export const LP_COMPANY_ADD = '/add-lp-company';
export const LP_COMPANY_EDIT = '/edit-lp-company/:id';
export const LP_COMPANY_LIST = '/lp-companies/list';
export const createLpCompanyEditRoute = (id: string) =>
  `/edit-lp-company/${id}`;

export const LP_REVALUATIONS = '/revalue-lp-asset/:id';
export const createLpCompanyRevaluationsRoute = (id: string) =>
  LP_REVALUATIONS.replace(':id', id);

export const VEHICLES = '/vehicles';
export const VEHICLE_ADD = '/add-vehicle';
export const LP_FIRM_SETTINGS = '/lp-firm-settings';

export const createFundSetupRoute = (tab?: FundSetupTab) =>
  `${FUND_SETUP}#${tab ?? ''}`;

export const createAccountingRoute = (tab?: AccountingTab) =>
  `${ACCOUNTING}${tab ? `#${tab}` : ''}`;

export const LP_ONBOARDING = '/onboarding';

export const createOnboardingRoute = (tab?: OnboardingTab) =>
  `${LP_ONBOARDING}${tab ? `#${tab}` : ''}`;
export const createViewVehicleApplicationRoute = (
  vehicleApplicationId?: string,
  tab?: string,
) =>
  `${LP_ONBOARDING}?vehicleApplicationId=${vehicleApplicationId}${
    tab ? `&tab=${tab}` : ''
  }`;

export const INCOME_OR_EXPENSE_ADD = '/add-income-or-expense/:type';
export const createIncomeOrExpenseAddRoute = (type?: IncomeOrExpenseType) =>
  INCOME_OR_EXPENSE_ADD.replace(':type', type ?? IncomeOrExpenseType.Income);
export const INCOME_OR_EXPENSE_EDIT = '/edit-income-or-expense/:id';
export const INCOME_OR_EXPENSE_LIST = '/income-and-expenses';
export const INCOME_OR_EXPENSE_VIEW = '/view-income-or-expense/:id';
export const createIncomeOrExpenseViewRoute = (id: string) =>
  INCOME_OR_EXPENSE_VIEW.replace(':id', id);

export const REVERSAL_CREATE = '/reversal/create/:type/:actionId';
export const createReversalRoute = (
  actionId: string,
  type = 'income-or-expense',
) => REVERSAL_CREATE.replace(':type', type).replace(':actionId', actionId);
export const REVERSAL_VIEW = '/reversal/view/:type/:actionId';
export const createReversalViewRoute = (
  actionId: string,
  type = 'income-or-expense',
) => REVERSAL_VIEW.replace(':type', type).replace(':actionId', actionId);

export const INCOME_OR_EXPENSE_SUCCESS = '/income-or-expense-success/:type';
export const createIncomeOrExpenseSuccessRoute = (type: IncomeOrExpenseType) =>
  INCOME_OR_EXPENSE_SUCCESS.replace(':type', type);

export const LP_INVESTMENT_CREATE = '/investment/create';
export const LP_INVESTMENT_EDIT = '/investment/edit/:id';
export const LP_INVESTMENT_VIEW = '/investment/view/:id';
export const LP_INVESTMENT_LIST = '/investment/list';
export const LP_INVESTMENT_SUCCESS =
  '/investment/success/:assetId/:fundingSource/:showRevaluation';
export const createLpInvestmentSuccessRoute = (
  assetId: string,
  fundingSource: FundingSource,
  showRevaluation: boolean,
) =>
  LP_INVESTMENT_SUCCESS.replace(':assetId', assetId)
    .replace(':fundingSource', fundingSource)
    .replace(':showRevaluation', showRevaluation ? 'true' : 'false');

export const LP_MANUAL_ACTION_LIST = '/manual-journal/list';
export const LP_MANUAL_ACTION_CREATE = '/manual-journal/create';
export const LP_MANUAL_ACTION_EDIT = '/manual-journal/:id/edit';
export const createManualActionEditRoute = (id: string) =>
  LP_MANUAL_ACTION_EDIT.replace(':id', id);

export const LP_REALISATION_CREATE = '/realisation/create';
export const LP_REALISATION_LIST = '/realisation/list';
export const LP_REALISATION_VIEW = '/realisation/view/:id';
export const createLpRealisationViewRoute = (id: string) =>
  LP_REALISATION_VIEW.replace(':id', id);

export const LP_CAPITAL_ACTION_LIST = '/capital-actions';
export const LP_CAPITAL_ACTION_CREATE = '/capital-action/create';
export const LP_CAPITAL_ACTION_EDIT = '/capital-action/:id/edit';
export const createLpCapitalActionEditRoute = (id: string) =>
  LP_CAPITAL_ACTION_EDIT.replace(':id', id);
export const LP_CAPITAL_ACTION_CREATE_SUCCESS = '/capital-action/:id/success';
export const createLpCapitalActionSuccessRoute = (id: string) =>
  LP_CAPITAL_ACTION_CREATE_SUCCESS.replace(':id', id);

export const LP_CAPITAL_ACTION_NOTICE_CREATE =
  '/capital-action/:id/create-notice';
export const createLpCapitalActionNoticeCreateRoute = (
  capitalActionId: string,
) => LP_CAPITAL_ACTION_NOTICE_CREATE.replace(':id', capitalActionId);

export const EQUALISATIONS_EDITOR = '/equalisations/:id/editor';
export const createEqualisationEditorRoute = (id: string) =>
  EQUALISATIONS_EDITOR.replace(':id', id);
export const EQUALISATIONS = '/equalisations/list';
export const EQUALISATIONS_PROCESS_CLOSE_SUCCESS = '/equalisations/success';

export const EQUALISATIONS_ADD = '/equalisations/add';

export const createIncomeOrExpenseEditRoute = (id: string) =>
  INCOME_OR_EXPENSE_EDIT.replace(':id', id);

export const createIncomeOrExpenseSwitchRoute = (id: string) =>
  `${createIncomeOrExpenseEditRoute(id)}?mode=switch`;

export const createLpInvestmentEditRoute = (id: string) =>
  LP_INVESTMENT_EDIT.replace(':id', id);

export const createLpInvestmentViewRoute = (id: string) =>
  LP_INVESTMENT_VIEW.replace(':id', id);

export const PARTNER_TRANSFERS_LIST = '/partner-transfers';
export const PARTNER_TRANSFERS_CREATE = '/partner-transfers/create';
export const PARTNER_TRANSFERS_EDIT = '/partner-transfers/:id';
export const createPartnerTransfersRoute = (id?: string) =>
  id ? `/partner-transfers/${id}` : '/partner-transfers';
export const createPartnerTransfersEditRoute = (id: string) =>
  `/partner-transfers/${id}`;
export const createPartnerTransfersCreateRoute = () =>
  '/partner-transfers/create';

export const BANK_RECONCILIATION = '/bank-reconciliation';

export const LP_INVESTOR_UPDATES = '/investor-updates';
export const PERIOD_END_REPORT_LIST = '/investor-updates/period-end-report';
export const PERIOD_END_REPORT_CREATE =
  '/investor-updates/period-end-report/:accountingPeriodId/create';
export const createPeriodEndReportCreateRoute = (accountingPeriodId: string) =>
  PERIOD_END_REPORT_CREATE.replace(':accountingPeriodId', accountingPeriodId);
export const PERIOD_END_REPORT_EDIT =
  '/investor-updates/period-end-report/:id/edit';
export const createPeriodEndReportEditRoute = (id: string) =>
  PERIOD_END_REPORT_EDIT.replace(':id', id);
export const BULLETIN_UPDATE_CREATE =
  '/investor-updates/bulletin-update/create';
export const BULLETIN_UPDATE_EDIT =
  '/investor-updates/bulletin-update/:id/edit';
export const createBulletinUpdateEditRoute = (id: string) =>
  BULLETIN_UPDATE_EDIT.replace(':id', id);

export const LP_PERIOD_END_REVIEW = '/period-end-review';
export const LP_PERIOD_END_REVIEW_DETAIL = '/period-end-review/:periodId';
export const createLpPeriodEndReviewDetailRoute = (periodId: string) =>
  LP_PERIOD_END_REVIEW_DETAIL.replace(':periodId', periodId);

export const LINKED_PORTALS = '/linked-portals';
export const LINKED_PORTALS_ADD = '/add-linked-portal';

export const DATA_TOOLS = '/data-tools';

export const USER_MANAGEMENT = '/user-management';
